export const DEFAULT_PLACEHOLDER_STRING = 'Select...';
export const DEFAULT_OPTIONS_EMPTY_STRING = 'No options found';

export const BASE_DEFAULT_PROPS = {
  baseClassName: 'rdn',
};

export enum ITEM_TYPE {
  LABEL = 'LABEL',
  OPTION = 'OPTION',
}

export const OPTION_PROPS = [
  'view',
  'label',
  'value',
  'className',
  'id',
  'disabled',
];
